import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import dayjs from "dayjs"

import {
  Avatar,
  Button,
  Box,
  Checkbox,
  Container,
  DateTimePicker,
  Modal,
  Paper,
  Typography,
  Stack,
  TextField,
} from "src/UILibrary"

export const Reservations = () => {
  const { t } = useTranslation("translation", { keyPrefix: "reservation" })
  const [modalOpened, setModalOpened] = useState(false)

  return (
    <Container maxWidth="xl" sx={{ px: "3.125rem", py: "2.5rem" }}>
      <Typography.Large color="textPrimary">{t("make_reservation")}</Typography.Large>

      <Paper elevation={0} sx={{ p: "1.25rem", mt: "2.5rem" }}>
        <Typography.Title>{t("talk_consultant")}</Typography.Title>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            mt: "1.25rem",
            gap: "20px",
          }}
        >
          <Avatar alt="Taro Sato" sx={{ width: 150, height: 200 }} variant="square" />

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Typography.Title>佐藤 太郎</Typography.Title>
            <Typography.Description sx={{ fontSize: 18 }}>
              弁護士（専門分野が表示される）
            </Typography.Description>
            <Typography.Description sx={{ fontSize: 18 }}>
              複数あれば下に連なるように記載される
            </Typography.Description>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={0} sx={{ p: "1.25rem", my: "3.75rem" }}>
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": { m: 1, width: "25ch" },
          }}
          noValidate
          autoComplete="off"
        >
          <Typography.Title>{t("preferred_consultation_date")}</Typography.Title>
          <Stack direction="row" alignItems="center">
            <Typography.Description>{t("1st_choice")}</Typography.Description>
            <DateTimePicker value={dayjs()} onChange={console.log} />
          </Stack>
          <Stack direction="row" alignItems="center">
            <Typography.Description>{t("2nd_choice")}</Typography.Description>
            <DateTimePicker value={dayjs()} onChange={console.log} />
          </Stack>
          <Stack direction="row" alignItems="center">
            <Typography.Description>{t("3rd_choice")}</Typography.Description>
            <DateTimePicker value={dayjs()} onChange={console.log} />
          </Stack>

          <Typography.Title sx={{ mt: "1.25rem" }}>
            {t("preferred_consultation_method")}
          </Typography.Title>
          <Checkbox label={t("in_person")} />
          <Checkbox label={t("phone")} />
          <Checkbox label={t("online")} />

          <Typography.Title sx={{ mt: "1.25rem" }}>
            {t("startup_preparatory_stage")}
          </Typography.Title>
          <Checkbox label={t("wonder_start")} />
          <Checkbox label={t("not_decided_when_to_start")} />
          <Checkbox label={t("start_in_3_months")} />
          <Checkbox label={t("start_in_a_year")} />
          <Checkbox label={t("already_started")} />
          <Checkbox label={t("no_business_intention")} />

          <Typography.Title sx={{ mt: "1.25rem" }}>
            {t("about_entrepreneurial_plan")}
          </Typography.Title>
          <Checkbox label={t("no_idea")} />
          <Checkbox label={t("not_concrete")} />
          <Checkbox label={t("not_progressing")} />
          <Checkbox label={t("plan_almost_ready")} />
          <Checkbox label={t("plan_completed")} />
          <Checkbox label={t("plan_submitted")} />

          <Typography.Title sx={{ mt: "1.25rem" }}>{t("business_overview")}</Typography.Title>
          <TextField
            multiline
            variant="standard"
            rows={5}
            fullWidth
            placeholder={t("business_overview_placeholder")}
            sx={{
              bgcolor: "transparent",
            }}
          />

          <Typography.Title sx={{ mt: "1.25rem" }}>{t("consultant_summary")}</Typography.Title>
          <TextField
            multiline
            variant="standard"
            rows={5}
            fullWidth
            placeholder={t("consultant_summary_placeholder")}
            sx={{
              bgcolor: "transparent",
            }}
          />
        </Box>

        <Button
          variant="contained"
          sx={{
            mt: "3.125rem",
            mx: "0.5rem",
            width: 240,
            borderRadius: 0,
            ":hover": {
              bgcolor: "#2DA389",
            },
          }}
          onClick={() => setModalOpened(true)}
        >
          {t("send")}
        </Button>
      </Paper>

      <Modal open={modalOpened} onClose={() => setModalOpened(false)}>
        <Stack direction="column" alignItems="center" justifyContent="center" height="100%">
          <Typography.Large color="textPrimary">{t("appointment_sent")}</Typography.Large>
          <Typography.Description sx={{ mt: "1.25rem" }}>
            {t("will_receive_email_in_a_week")}
          </Typography.Description>

          <Paper elevation={0} sx={{ p: "1.25rem", mt: "5rem", width: "100%" }}>
            <Typography.Title>{t("applying_consultant_request")}</Typography.Title>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                mt: "1.25rem",
                gap: "20px",
              }}
            >
              <Avatar alt="Taro Sato" sx={{ width: 150, height: 200 }} variant="square" />

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <Typography.Title>佐藤 太郎</Typography.Title>
                <Typography.Description sx={{ fontSize: 18 }}>
                  弁護士（専門分野が表示される）
                </Typography.Description>
                <Typography.Description sx={{ fontSize: 18 }}>
                  複数あれば下に連なるように記載される
                </Typography.Description>
              </Box>
            </Box>
          </Paper>
        </Stack>
      </Modal>
    </Container>
  )
}
